//Styles
import Styles from "./styles.module.scss";
import serviceAgreementLink from "../../documents/Parent – Specialist Agreement.pdf";

const ServiceAgreement = () => {
  return (
    <section className={Styles.wrapper}>
      <h3 style={{ marginBottom: "20px" }}>Service Agreement</h3>
      <iframe
        title="service-agreement"
        src={`${serviceAgreementLink}#toolbar=0&navpanes=0`}
        height={"100%"}
        width={"100%"}
      />
    </section>
  );
};

export default ServiceAgreement;
